import React from "react";
import { Button } from "reactstrap";

type Props = Readonly<{
  disabled: boolean;
  onClick: () => void;
}>;

export const SaveButton = ({ disabled, onClick }: Props) => {
  return (
    <Button
      color="success"
      disabled={disabled}
      type="button"
      onClick={onClick}
      title="Not implemented yet!"
    >
      Save
    </Button>
  );
};
SaveButton.displayName = "SaveButton";
